import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { pilarDigital } from '../sortilegioContent';

const PilarDigital = () => (
  <Box py={{ xs: 8, md: 10 }}>
    <SectionHeader
      overline={pilarDigital.overline}
      title={pilarDigital.title}
      subtitle={pilarDigital.subtitle}
      icon="devices"
      align="left"
      maxWidth="100%"
    />
    <Grid container spacing={3}>
      {pilarDigital.items.map((item) => (
        <Grid item xs={12} md={4} key={item.title}>
          <GlassCard data-aos="fade-up">
            <CardContent sx={{ p: 3 }}>
              <Box mb={2}>
                <IconBadge icon={item.icon} variant="gradient" size={44} rounded="12px" />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                {item.title}
              </Typography>
              <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                {item.text}
              </Typography>
            </CardContent>
          </GlassCard>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default PilarDigital;
